import { useQuery } from '@tanstack/react-query';

import api from 'core/api';

import {
  NOTIFICATION_URL,
  /* NOTIFICATION_PILOT,
  CURRENT_NOTIFICATION, */
} from 'utils/api';

async function getNotification() {
  const { data } = await api.get(NOTIFICATION_URL);
  return data;
}

function useNotification() {
  return useQuery(['notifications'], getNotification);
}

export default useNotification;
